import React, { useState } from "react";
import { FiZoomIn } from "react-icons/fi";
import styles from "./ProductGallery.module.css";

interface ProductGalleryProps {
  images?: string[];
  alt?: string;
  brandLogo?: string;
  brand?: {
    name: string;
  };
}

const FALLBACK_IMAGE = "https://mechmiles.com/not-available.png";

const ProductGallery: React.FC<ProductGalleryProps> = ({
  images,
  alt,
  brandLogo,
  brand,
}) => {
  const gallery = images && images.length > 0 ? images : [FALLBACK_IMAGE];
  const [activeIndex, setActiveIndex] = useState(0);
  const [position, setPosition] = useState({ x: 50, y: 50 });
  const [isZoomed, setIsZoomed] = useState(false);

  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    const { left, top, width, height } =
      e.currentTarget.getBoundingClientRect();

    const x = ((e.clientX - left) / width) * 100;
    const y = ((e.clientY - top) / height) * 100;

    setPosition({ x, y });
  };
  return (
    <div className={styles.gallery}>
      <div className={styles.thumbnailRail}>
        {gallery.map((img, index) => (
          <button
            key={index}
            type="button"
            className={`${styles.thumbnailBtn} ${
              activeIndex === index ? styles.thumbnailActive : ""
            }`}
            onClick={() => setActiveIndex(index)}
            aria-label={`View image ${index + 1}`}
          >
            <img src={img} alt={`${alt} thumbnail ${index + 1}`} />
          </button>
        ))}
      </div>

      <div
        className={styles.mainImageWrapper}
        onMouseMove={isZoomed ? handleMouseMove : undefined}
      >
        {brand?.name && (
          <div className={styles.brandLogoBox}>
            <span className={styles.brandLogo}>{brand.name}</span>
          </div>
        )}

        <img
          src={gallery[activeIndex] || FALLBACK_IMAGE}
          className={styles.mainImage}
          style={{
            transform: isZoomed ? "scale(2)" : "scale(1)",
            transformOrigin: `${position.x}% ${position.y}%`,
          }}
        />

        <button
          className={styles.zoomBtn}
          onClick={() => {
            if (isZoomed) {
              setPosition({ x: 50, y: 50 });
            }
            setIsZoomed(!isZoomed);
          }}
        >
          <FiZoomIn size={18} />
        </button>
      </div>
    </div>
  );
};

export default ProductGallery;
